import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import env from '@env';
import { formSubmit, creditEdit } from '@/util/Form';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import { UserPaymentMethodEnum, UserNgPaymentMethodEnum } from '@/generated/api';

@Component({
    components: AllComponents(),
})
export default class PaymentMethod extends Mixins(CommonView) {
    public kurukuru: boolean = false;
    public error: string = "";
    public paymentMethod: UserPaymentMethodEnum | null = UserPaymentMethodEnum.CARD;
    public ngPaymentMethod: UserNgPaymentMethodEnum | null = null;

    public async created() {
        if (await this.isLoginRedirect(true)) return;

        let userRes = await SBAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);

        if (isAxiosError(userRes)) {
            this.error = "" + userRes.data;
            return;
        }

        if (userRes.data.paymentMethod) {
            this.paymentMethod = userRes.data.paymentMethod;
        }

        if (userRes.data.ngPaymentMethod) {
            this.ngPaymentMethod = userRes.data.ngPaymentMethod;
        }

        if (this.$route.query.err) {//戻るを押した場合、決済をやめるを押した場合
            return;
        }

        if (this.$route.query.token) {
            // 決済方法遷移戻り
            if (!this.$route.query.paymentMethod) {
                this.error = "リクエストが不正です。";
                return;
            }
            if (!this.loginStatus) {
                this.error = "リクエストが不正です。";
                return;
            }
            if (this.$route.query.token !== this.loginStatus.session) {
                this.error = "リクエストが不正です。";
                return;
            }
            await this.updateUserPaymentMethod(<UserPaymentMethodEnum>("" + this.$route.query.paymentMethod));
            return;
        }

    }

    public async card() {
        if (!this.loginStatus) {
            this.error = "不正なリクエストです。";
            return;
        }
        try {
            if (this.$route.query.slug == null && this.$route.query.planId == null) {
                let res = await creditEdit("2", "/api/credit/callBack?url=" + encodeURIComponent("/mypage/profile/payment?token=" + this.loginStatus.session + "&paymentMethod=" + this.paymentMethod), "/mypage/profile/payment?err=true");
            } else {
                let res = await creditEdit("2", "/api/credit/callBack?url=" + encodeURIComponent("/mypage/profile/payment?token=" + this.loginStatus.session + "&paymentMethod=" + this.paymentMethod + "&slug=" + this.$route.query.slug + "&planId=" + this.$route.query.planId), "/mypage/profile/payment?err=true");
            }
        } catch (error) {
            this.error = "" + error;
            return;
        }
    }

    public async button() {
        if (!this.loginStatus) {
            this.error = "不正なリクエストです。";
            return;
        }
        if (!this.paymentMethod) {
            this.error = "決済方法を選択してください";
            return;
        }

        //決済方法遷移
        if (this.paymentMethod === UserPaymentMethodEnum.CARD) {
            // カード遷移
            await this.card();
            return;
        } else if (this.paymentMethod === UserPaymentMethodEnum.GMOAB) {
            // 遷移しないで確定
            await this.updateUserPaymentMethod(this.paymentMethod);
            return;
        }

        throw "えらー";
    }

    public async updateUserPaymentMethod(paymentMethod: UserPaymentMethodEnum) {
        this.kurukuru = true;
        let response1 = await SBAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(response1)) {
            this.error = "" + response1.data;
            this.kurukuru = false;
            return;
        }
        response1.data.email = "";

        response1.data.paymentMethod = paymentMethod;

        let response2 = await SBAPI.UserController.putUserUsingPUT(response1.data).catch(AxiosErrorHandler);
        if (isAxiosError(response2)) {
            this.error = "" + response2.data;
            this.kurukuru = false;
            return;
        }

        this.kurukuru = false;

        if (this.$route.query.slug == null && this.$route.query.planId == null) {
            this.$router.push("/mypage/profile");
        } else {
            this.$router.push("/lineup/" + this.$route.query.slug + "/plan/" + this.$route.query.planId + "/checkout");
        }
    }
}
